import { Collections } from '../../firebase/firestore/collections';
import { BUNDLE_ID_GLOBAL, TIMEZONE_ENABLED } from '../../firebase/firestore/constants';
import { GroupEventConfiguration } from '../../firebase/firestore/documents/groupEvent';
import { useQuerySnapshot } from '../../firebase/firestore/hooks';
import { Query } from '../../firebase/firestore/query/query';

export const useTimezoneEnabled = (): number | undefined => {
  const isTimezoneEnabled = useQuerySnapshot<GroupEventConfiguration>(Collections.CONFIGURATION, [
    Query.field('bundleId').equals(BUNDLE_ID_GLOBAL),
    Query.field('name').equals(TIMEZONE_ENABLED),
  ]);
  if (isTimezoneEnabled) {
    return isTimezoneEnabled[0]?.value;
  }
  return undefined;
};

export default useTimezoneEnabled;
